var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStepVideo = function SvgStepVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21 16.416-4-2.488v-3.789l4-2.555v8.832ZM16 17.5a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v11Zm5.48-10.793a1.004 1.004 0 0 0-1.018.034L17 8.951V6.5c0-.827-.673-1.5-1.5-1.5h-12C2.673 5 2 5.673 2 6.5v11c0 .827.673 1.5 1.5 1.5h12c.827 0 1.5-.673 1.5-1.5v-2.395l3.472 2.161a1.008 1.008 0 0 0 1.013.024c.318-.177.515-.512.515-.874V7.584a1 1 0 0 0-.52-.877Z",
    fill: "#000"
  })));
};
export default SvgStepVideo;